import { money, fmtDate } from "@/lib/format";

export const STATUS = [["", "All"], ["full", "Paid in full"], ["partial", "Partially paid"], ["none", "Not started"]];
export const statusOf = (m) => (m.paid <= 0 ? "none" : m.paid >= m.goal ? "full" : "partial");
export const NOF = { q: "", church: "", status: "" };
export function groupMembers(members, order = []) {
  const map = new Map();
  members.forEach((m) => { if (!map.has(m.church_id)) map.set(m.church_id, [m.church_id, m.church_name, []]); map.get(m.church_id)[2].push(m); });
  const rank = (id) => { const i = order.indexOf(id); return i < 0 ? order.length : i; };
  const first = [...map.keys()];
  return [...map.values()].sort((a, b) => rank(a[0]) - rank(b[0]) || first.indexOf(a[0]) - first.indexOf(b[0]));
}

export function filterMembers(members, f) {
  const q = f.q.trim().toLowerCase();
  return members.filter((m) => (!q || m.name.toLowerCase().includes(q)) && (!f.church || m.church_name === f.church) && (!f.status || statusOf(m) === f.status));
}

export function filterText(f) {
  const parts = [f.church && `Church: ${f.church}`, f.q.trim() && `Name contains: "${f.q.trim()}"`, f.status && `Status: ${STATUS.find(([k]) => k === f.status)[1]}`].filter(Boolean);
  return parts.length ? `Showing: ${parts.join(" · ")}` : "Showing: All churches and people";
}

const sum = (list, k) => Math.round(list.reduce((a, m) => a + m[k], 0) * 100) / 100;

export function specialSections(view, members, exp, order = []) {
  if (view === "expenses") {
    const rows = exp?.expenses || [];
    return [
      { title: "Totals", head: ["Total Income (paid so far)", "Total Expenses", "Balance left"], body: [[exp?.income || 0, exp?.total_expenses || 0, exp?.balance || 0]], moneyCols: [0, 1, 2] },
      { title: "Expenses", head: ["Date", "Description", "Note", "Amount"], body: rows.map((r) => [fmtDate(r.date), r.description, r.note || "", r.amount]), foot: [`TOTAL (${rows.length})`, "", "", exp?.total_expenses || 0], moneyCols: [3] },
    ];
  }
  if (view === "details") {
    const head = ["Name", "Church", "Goal", "Payments", "Paid", "Balance"];
    const groups = groupMembers(members, order).map(([, c, list]) => ({
      title: c,
      head,
      body: list.map((m) => [m.name, m.church_name, m.goal, m.payments.map((p) => `${money(p.amount)} (${fmtDate(p.date)})`).join("\n") || "—", m.paid, m.balance]),
      foot: [`Subtotal (${list.length})`, "", sum(list, "goal"), "", sum(list, "paid"), sum(list, "balance")],
      moneyCols: [2, 4, 5],
    }));
    return [...groups, {
      title: "Totals",
      head: ["People", "Payments", "Goal", "Paid", "Balance"],
      body: [[`TOTAL (${members.length} people)`, `${members.reduce((a, m) => a + m.payments.length, 0)} payment(s)`, sum(members, "goal"), sum(members, "paid"), sum(members, "balance")]],
      moneyCols: [2, 3, 4],
    }];
  }
  const groups = groupMembers(members, order).map(([, c, l]) => [c, l]);
  return [
    { title: "Totals", head: ["Total goals", "Total paid", "Total balance"], body: [[sum(members, "goal"), sum(members, "paid"), sum(members, "balance")]], moneyCols: [0, 1, 2] },
    {
      title: "Totals by church",
      head: ["Church", "People", "Goal", "Paid", "Balance"],
      body: groups.map(([c, l]) => [c, l.length, sum(l, "goal"), sum(l, "paid"), sum(l, "balance")]),
      foot: ["TOTAL", members.length, sum(members, "goal"), sum(members, "paid"), sum(members, "balance")],
      moneyCols: [2, 3, 4],
    },
  ];
}
